module.exports = __webpack_public_path__ + "static/media/new-relic.7164c357.svg";